<div class="service-orbit-visual" #visualRoot>
  <div class="service-orbit-glow" aria-hidden="true"></div>
  <div class="service-orbit-rings" aria-hidden="true">
    <span class="service-orbit-ring service-orbit-ring--outer"></span>
    <span class="service-orbit-ring service-orbit-ring--dashed"></span>
    <span class="service-orbit-ring service-orbit-ring--middle"></span>
    <span class="service-orbit-ring service-orbit-ring--inner"></span>
    <span class="service-orbit-particle service-orbit-particle--one"></span>
    <span class="service-orbit-particle service-orbit-particle--two"></span>
    <span class="service-orbit-particle service-orbit-particle--three"></span>
    <span class="service-orbit-particle service-orbit-particle--four"></span>
  </div>
  <div class="service-orbit-core">
    <i [class]="iconClass" aria-hidden="true"></i>
  </div>
  <div class="service-orbit-ground" aria-hidden="true"></div>
</div>
